// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { infoSlideStyles } from "@sc/App/Widgets/InfoSlide/InfoSlide";
import { color, ellipsis, hideElementOnPrint } from "@sc/XDL/Utilities";
import { css } from "styled-components";

infoSlideStyles.container = {
    css: css`
        height: 100%;
        border: 1px solid ${color("common.border")};
        display: flex;
        flex-direction: column;
        gap: 8px;

        ${hideElementOnPrint}
    `,
};

infoSlideStyles.image = {
    css: css`
        width: 100%;
        height: auto;
        margin-bottom: 4px;

        img {
            max-height: 110px;
        }
    `,
};

infoSlideStyles.titleTypography = {
    variant: "h4",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
        padding: 0 12px;
    `,
};

infoSlideStyles.descriptionTypography = {
    css: css`
        flex-grow: 1;
        ${TypographyStyle} {
            margin-bottom: 0;
            font-size: 14px;
            line-height: 22px;
            padding: 0 12px;
            color: ${color("common.ui6")};
        }
        ${({ maxNumberOfDescriptionLines }: any) =>
            css`
                ${ellipsis(maxNumberOfDescriptionLines)};
            `}
    `,
};

infoSlideStyles.action = {
    typographyProps: {
        size: 12,
        lineHeight: "17px",
        weight: "bold",
    },
    css: css`
        margin: 8px 12px 12px 12px;
        width: fit-content;
    `,
};
